import React, { memo, useCallback, useState } from 'react';

import style from './style.module.css';

const AddUserComponent = ({ sectionId, users, onUserAdd }) => {
  const [error, setError] = useState(null);
  const [value, setValue] = useState('');

  const handleChange = useCallback(
    event => {
      const inputValue = event.target.value;
      const match = users?.find(user => `${user.get('firstName')} ${user.get('lastName')}` === inputValue);

      if (match) {
        setError(null);
        setValue('');
        onUserAdd(match);
      } else if (inputValue) {
        setError(inputValue);
        setValue(inputValue);
      } else {
        setError(null);
        setValue('');
      }
    },
    [users, onUserAdd],
  );

  const placeholder = users?.size === 0 ? 'No unassigned people left' : 'Add user...';

  return (
    <tr>
      <td className="w45">
        <div className={style.addUser}>+</div>
      </td>
      <td>
        <div className="form-group">
          <input
            className="form-control input-lg bounded w260"
            list={`add-user-${sectionId}`}
            onChange={handleChange}
            placeholder={placeholder}
            value={value}
          />
          <datalist id={`add-user-${sectionId}`}>
            {users?.map(user => {
              const fullName = `${user.get('firstName')} ${user.get('lastName')}`;

              return <option key={user.get('id')} value={fullName} />;
            })}
          </datalist>
          {error && (
            <div className="row mt10">
              <div className="col-md-12">
                <p className="text-danger pl0">No unassigned user matches &quot;{error}&quot;</p>
              </div>
            </div>
          )}
        </div>
      </td>
      <td className="w180" />
    </tr>
  );
};

export const AddUser = memo(AddUserComponent);
